import React from 'react'

import * as S from './styles'

import WarehouseCell from '../WarehouseCell'
import { warehousesForApparel } from '../../constants'

const WarehouseRow = ({
  warehouseId,
  locationName,
  sizes,
  columns,
  inventoryLocations,
}) => {
  // Helper function to get aggregated quantityOnOrder for apparel
  const getQuantityOnOrder = (columnName, cellData) => {
    // If this is FIEGE00 (warehouseId 2), aggregate quantityOnOrder from all apparel
    if ((warehouseId === '2' || warehouseId === 2) && inventoryLocations) {
      const total = Object.keys(warehousesForApparel).reduce(
        (acc, apparelWarehouseId) => {
          // Look up the apparel warehouse in inventoryLocations using its ID
          const apparelWarehouse =
            inventoryLocations[apparelWarehouseId] ||
            inventoryLocations[String(apparelWarehouseId)]

          console.info(
            `Looking for warehouse ${apparelWarehouseId}:`,
            apparelWarehouse ? 'Found' : 'Not found',
          )

          if (apparelWarehouse && apparelWarehouse.sizes) {
            const matchingSize = apparelWarehouse.sizes.find(
              ({ value, SKU }) => value === columnName || SKU === columnName,
            )
            if (matchingSize) {
              acc += matchingSize.quantityOnOrder
            }
          }
          return acc
        },
        Number(cellData?.quantityOnOrder || 0),
      )

      return total
    }
    // Otherwise, just return the quantityOnOrder from the specific warehouse
    return cellData?.quantityOnOrder || 0
  }

  return (
    <>
      <S.IDCell>{warehouseId}</S.IDCell>
      <S.BoldCell>{locationName}</S.BoldCell>
      {columns.map(({ name, id, internalId }) => {
        const cell = sizes.filter(
          ({ value, SKU }) => value === name || SKU === name,
        )[0]

        if (!cell) {
          return (
            <WarehouseCell
              key={id}
              warehouseId={warehouseId}
              SKU={name}
              internalId={internalId}
              value={name}
              quantity={0}
              quantityOnOrder={0}
            />
          )
        } else {
          const { id, SKU, internalId: cellId, quantityAvailable, value } = cell
          return (
            <WarehouseCell
              key={id || SKU}
              warehouseId={warehouseId}
              SKU={SKU}
              internalId={cellId}
              value={value}
              quantity={quantityAvailable}
              quantityOnOrder={getQuantityOnOrder(name, cell)}
            />
          )
        }
      })}
      <div
        style={{
          textAlign: 'center',
          borderLeft: '1px solid #eee',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ padding: '4px 0' }}>
          {sizes.reduce(
            (acc, { quantityAvailable }) => quantityAvailable + acc,
            0,
          )}
        </div>
      </div>
    </>
  )
}

export default WarehouseRow
